<template>
    <div>
        <MainContentTabs
            :tabs="[
                {tab : 'normal', nombre: 'Informe'},
                {tab : 'desglose-ventas', nombre: 'Desglose de ventas'},
            ]"
            initialTab="normal"
            title="ABONOS"
        >
            <template slot="extra-data">
                <b-row class="mb-3" style="margin: 0">
                    <b-col cols="12" md="4">
                        <div class="form-group mt-2">
                            <label for="temporada">Temporada</label>
                            <multiselect
                                v-model="temporada"
                                placeholder="Temporada"
                                label="nombre"
                                track-by="id"
                                :options="temporadas"
                                :multiple="false"
                                :allow-empty="false"
                            />
                        </div>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div>
                            <div class="form-group">
                                <label for="del">DEL</label>
                                <input type="date" class="form-control" id="del" placeholder="Del" v-model="fecha_inicio"/>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="form-group">
                            <label for="al">AL</label>
                            <input type="date" class="form-control" id="al" placeholder="Al" v-model="fecha_fin"/>
                        </div>
                    </b-col>
                    <b-col cols="12" class="text-right">
                        <Button @click="recargar()" class="mr-2 width-responsive">Aplicar filtros</Button>
                        <Button @click="limpiarFiltros()" class="width-responsive">Limpiar filtros</Button>
                    </b-col>
                </b-row>
            </template>
            <template slot="normal">
                <Informe :key="reloadComponent" :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" @recargar="recargar()" />
            </template>
            <template slot="desglose-ventas">
                <DesgloseVentas :key="reloadComponent" :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" @recargar="recargar()" />
            </template>
        </MainContentTabs>
    </div>
</template>

<script>
    import MainContentTabs from '@/components/backend/components/MainContentTabs.vue';
    import Informe from '@/components/backend/abonos/informes/Informe.vue';
    import DesgloseVentas from '@/components/backend/abonos/informes/DesgloseVentas.vue';

    export default {
        data() {
            return {
                lista_id: this.$store.getters.getListaId,
                fecha_inicio: null,
                fecha_fin: null,
                temporada: null,
                reloadComponent: 1
            }
        },
        methods: {
            setTemporadaActiva() {
                this.temporada = this.temporadas.find(temporada => temporada.id === this.lista_id)
            },
            recargar() {
                if (this.temporada) {
                    this.lista_id = this.temporada.id;
                } else {
                    this.lista_id = this.$store.getters.getListaId;
                }

                this.reloadComponent += 1;
            },
            limpiarFiltros() {
                this.fecha_inicio = null;
                this.fecha_fin = null;

                this.recargar();
            }
        },
        computed: {
            temporadas() {
                return this.$store.getters.getListas;
            }
        },
        created() {
            this.setTemporadaActiva();
        },
        components: {
            MainContentTabs, Informe, DesgloseVentas
        }
    }
</script>

<style scoped>
     @media (max-width: 700px) {
        .width-responsive {
            width: 100%;
            margin-bottom: 5px;
            margin-left: 0 !important;
        }
     }
</style>
